<template>
    <div
        class="flex justify-between gap-x-4 py-3"
        data-spec-class="card_list_item"
    >
        <dt class="text-tertiary">
            {{ label }}
            <slot name="label" />
        </dt>
        <dd
            class="text-secondary"
            :class="{ truncate: isTruncated }"
            :style="isTruncated ? `max-width: ${maxWidth};` : ''"
            :title="isTruncated ? title || value : undefined"
        >
            <RouterLink
                v-if="to"
                :to="to"
                class="cursor-pointer text-brand hover:text-brand--light hover:underline"
            >
                {{ value }}
                <slot></slot>
            </RouterLink>
            <template v-else>
                {{ value }}
                <slot></slot>
            </template>
        </dd>
    </div>
</template>

<script lang="ts" setup>
import { withDefaults, defineProps } from 'vue';
import { RouteLocationNormalized } from 'vue-router';

interface Props {
    label?: string;
    value?: string;
    to?: RouteLocationNormalized;
    isTruncated?: boolean;
    maxWidth?: string;
    title?: string;
}

withDefaults(defineProps<Props>(), {
    label: undefined,
    value: undefined,
    to: undefined,
    isTruncated: false,
    maxWidth: '200px',
    title: undefined,
});
</script>
